import { Inject, Injectable } from '@angular/core';
import {
  ApiService,
  AuthService,
  EnvironmentService,
  HttpRequestService,
  LogService,
  NotificationService,
  PagedResultGeneric,
  UtilService,
} from 'src/app/shared';
import { ServiceApiService } from 'src/app/shared/api/service-api.service';
import { EcomOptionsTypeSerachDto } from './dto/ecom-options-type-search.dto';
import { EcomOptionsTypeDto } from './dto/ecom-options-type.dto';

@Injectable({
  providedIn: 'root',
})
export class EcomOptionsTypeService extends ServiceApiService {
  constructor(
    @Inject(AuthService) authService: AuthService,
    @Inject(UtilService) utilService: UtilService,
    @Inject(LogService) logService: LogService,
    @Inject(HttpRequestService) httpRequestService: HttpRequestService,
    @Inject(EnvironmentService) environmentService: EnvironmentService,
    @Inject(NotificationService) notificationService: NotificationService
  ) {
    super(authService, utilService, logService, httpRequestService, environmentService, notificationService, 'eCommerce');
  }

  search(searchDto: EcomOptionsTypeSerachDto): Promise<PagedResultGeneric<EcomOptionsTypeDto>> {
    let url = `ecommerce/v2/optiontypes`;
    return this.post(url, searchDto);
  }

  getOptionsType(id: number): Promise<EcomOptionsTypeDto> {
    return this.get(`ecommerce/v2/optionstype/${id}`);
  }

  createOptionsType(dto: EcomOptionsTypeDto): Promise<number> {
    return this.post('ecommerce/v2/optionstype', dto);
  }

  updateOptionsType(dto: EcomOptionsTypeDto): Promise<void> {
    return this.put(`ecommerce/v2/optionstype`, dto);
  }

  deleteOptionsType(id: number): Promise<void> {
    return this.delete(`ecommerce/v2/optionstype/${id}`);
  }
}
